module.exports = __webpack_public_path__ + "img/bg-lg-06.8261ef3b.jpg";